import { toString, html } from '@webtides/element-js';
import '../spec-price-filter/spec-price-filter';
import '../spec-box-filter/spec-box-filter';
import '../spec-color-filter/spec-color-filter';
import '../spec-color-list-filter/spec-color-list-filter';
import '../spec-list-filter/spec-list-filter';
import { classMap } from 'lit-html/directives/class-map.js';

const filterButtonIcon = html` <svg-icon name="arrow-right"></svg-icon> `;

const renderFilterByRenderType = (filter, meta = {}, { filterButtonIcon, filterButtonType }) => {
    const { renderType } = meta;
    const filterType = renderType || filter.renderType || '';

    switch (filterType) {
        case 'PRICE':
            return renderPriceFilter(filter, meta, { filterButtonIcon, filterButtonType });
        case 'BOX':
            return renderBoxFilter(filter, meta, { filterButtonIcon, filterButtonType });
        case 'COLOR_LIST':
            return renderColorListFilter(filter, meta, { filterButtonIcon, filterButtonType });
        case 'COLOR':
            return renderColorFilter(filter, meta, { filterButtonIcon, filterButtonType });
        case 'SINGLE_LIST':
            return renderSingleListFilter(filter, meta, { filterButtonIcon, filterButtonType });
        default:
            return renderListFilter(filter, meta, { filterButtonIcon, filterButtonType });
    }
};

const renderPriceFilter = (filter, filterMeta, { filterButtonIcon, filterButtonType }) => {
    return html`
        <spec-price-filter
            filter
            link="${toString(filterMeta.link)}"
            .meta="${filter.meta}"
            .values="${filter.values}"
            .filterButtonIcon=${filterButtonIcon}
            .filterButtonType=${filterButtonType}
            key="${filter.key}"
        ></spec-price-filter>
    `;
};

const renderBoxFilter = (filter, filterMeta, { filterButtonIcon, filterButtonType }) => html`
    <spec-box-filter
        filter
        link="${toString(filterMeta.link)}"
        .meta="${filter.meta}"
        key="${filter.key}"
        .values="${filter.values}"
        .filterButtonIcon=${filterButtonIcon}
        .filterButtonType=${filterButtonType}
        multiple="true"
    ></spec-box-filter>
`;

const renderColorFilter = (filter, filterMeta, { filterButtonIcon, filterButtonType }) => html`
    <spec-color-filter
        filter
        link="${toString(filterMeta.link)}"
        .meta="${filter.meta}"
        key="${filter.key}"
        .filterButtonIcon=${filterButtonIcon}
        .filterButtonType=${filterButtonType}
        .values="${filter.values}"
    ></spec-color-filter>
`;

const renderColorListFilter = (filter, filterMeta, { filterButtonIcon, filterButtonType }) => html`
    <spec-color-list-filter
        filter
        link="${toString(filterMeta.link)}"
        .meta="${filter.meta}"
        key="${filter.key}"
        .filterButtonIcon=${filterButtonIcon}
        .filterButtonType=${filterButtonType}
        .values="${filter.values}"
    ></spec-color-list-filter>
`;

const renderListFilter = (filter, filterMeta, { filterButtonIcon, filterButtonType }) => html`
    <spec-list-filter
        filter
        link="${toString(filterMeta.link)}"
        .meta="${filter.meta}"
        key="${filter.key}"
        .filterButtonIcon=${filterButtonIcon}
        .filterButtonType=${filterButtonType}
        .values="${filter.values}"
    ></spec-list-filter>
`;

const renderSingleListFilter = (filter, filterMeta, { filterButtonIcon, filterButtonType }) => html`
    <spec-list-filter
        filter
        link="${toString(filterMeta.link)}"
        .meta="${filter.meta}"
        key="${filter.key}"
        multiple="false"
        .filterButtonIcon=${filterButtonIcon}
        .filterButtonType=${filterButtonType}
        .values="${filter.values}"
    ></spec-list-filter>
`;

const renderActiveIndicator = filter => {
    const hasFilter = filter.values && filter.values.findIndex(value => value.selected === true) > -1;
    if (hasFilter) {
        return html`
            <div class="hidden lg:block filter-active-indicator flex-shrink-0">
                <svg-icon name="check" class="icon absolute inset-0"></svg-icon>
            </div>
        `;
    }
    return '';
};

const templateFactory =
    ({ filterButtonIcon, filterButtonType }) =>
    context => {
        return html`
            <hover-indicator
                selector=".filter-title"
                active="${context.activeIndex}"
                class="hover-indicator-border-color lg:border-b lg:flex lg:flex-wrap relative "
            >
                ${context.filter.map((filter, index) => {
                    const filterMeta = context.filterMeta.find(
                        meta => meta.key.toLowerCase() === filter.key.toLowerCase()
                    );
                    const hasFilter = filter.values && filter.values.findIndex(value => value.selected === true) > -1;
                    const cssClassesGroup = {
                        'has-filter': hasFilter,
                        many: context.many,
                        'lg:w-1/6': context.many,
                        'lg:w-1/5': !context.many,
                        'is-open': context.activeIndex === index,
                    };
                    const cssClassesFilterContent = {
                        'lg:hidden': context.activeIndex !== index,
                        'lg:pointer-events-none': context.activeIndex !== index,
                    };

                    return html`
                        <div
                            class="group filter-title relative text-center lg:cursor-pointer hover-bg-accent w-full ${classMap(
                                cssClassesGroup
                            )}"
                            ref="filterGroup[]"
                        >
                            <div
                                class="label py-8 lg:py-5 font-base w-full flex items-center justify-center"
                                open-filter
                                data-index="${index}"
                            >
                                ${filterMeta?.label || filter.label} ${renderActiveIndicator(filter)}
                            </div>

                            <div class="filter-content relative lg:absolute ${classMap(cssClassesFilterContent)} z-20">
                                ${renderFilterByRenderType(filter, filterMeta, { filterButtonIcon, filterButtonType })}

                                <hr class="hidden lg:block h-1 bg-black absolute bottom-0 left-0 right-0" />
                            </div>
                        </div>
                    `;
                })}
            </hover-indicator>
        `;
    };

export { templateFactory };

export default templateFactory({
    filterButtonIcon,
    filterButtonType: 'btn-brand',
});
